import type { ReactNode } from 'react'
import type { UploadSession } from '../types'
import { SessionStateScreen } from './session-state-screen'

function LoadingSkeleton() {
  return (
    <div className="space-y-4 pt-4">
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className="h-48 animate-pulse rounded-lg bg-[var(--skeleton-base)]"
          style={{ animationDelay: `${i * 100}ms` }}
        />
      ))}
    </div>
  )
}

interface SessionGateProps {
  session: UploadSession | undefined
  isLoading: boolean
  isError: boolean
  children: (session: UploadSession) => ReactNode
}

export function SessionGate({ session, isLoading, isError, children }: SessionGateProps) {
  if (isLoading) {
    return <LoadingSkeleton />
  }

  if (isError || !session) {
    return <SessionStateScreen state="not_found" />
  }

  if (session.state !== 'active') {
    return (
      <SessionStateScreen
        // WPS-164 3A: a just-submitted session (pending_review) shows the
        // "Evidence Submitted" confirmation, not the "already submitted" copy
        // reserved for revisiting a genuinely finalised session. Field forms
        // use their own copy so an engineer never sees "evidence".
        state={session.state === 'pending_review' ? 'submitted' : session.state}
        expiresAt={session.expires_at}
        finalisedAt={session.finalised_at}
        isForm={session.target_record_type === 'form_request'}
      />
    )
  }

  return <>{children(session)}</>
}
